export default "__VITE_ASSET__Ge4VbiS1__";